import DiscountService from './DiscountService';
import axios from 'axios';
import { CartService } from "@firenet-designs/shopify-common";

export default class ThemeService {
  constructor(settings) {
    this.settings = settings;
    this.isEnabled = settings.isEnabled;
    this.discountKey = settings.discountKey;
    this.couponCode = 'false';
    this.cartService = new CartService('shopify');

    if(!this.isEnabled){
      return;
    }
    this.initDiscount();
  }

  discountedProductExists() {
    return localStorage.getItem(this.discountKey) && localStorage.getItem(this.discountKey) !== 'false';
  }

  async initDiscount() {
    if (!this.discountedProductExists()) {
      const cart = await this.cartService.getCart();
      if(cart && cart.attributes && cart.attributes[this.discountKey] && cart.attributes[this.discountKey] !== "false"){
        this.cartService.updateAttributes({
          [this.discountKey]: 'false'
        });
      }

      return;
    }

    new DiscountService(this.settings);
  }
}